import { connect } from 'react-redux'
import {
  getOccupations,
  getOccupationsUserSubmission,
  setModalOccupationUserSubmission,
  setAction,
  setIdOccupationSelected,
  setFilterNameUserSubmission,
  setOccupationsUserSubmissionSelected,
  setIsModalMergeOpen,
  setInputMergeName,
  mergeOccupations,
  setTypeMerge,
  setExistingOccupationSelected,
  getOccupationSelection,
  setIsDialogAlertOpen,
  setDialogAlertMessage,
  setFilterSortUserSubmission,
  setDataTypeActive,
  setOccupationLiveDataSelected,
} from 'reduxpath/ducks/Occupation/List'

import {
  updateOccupation,
  setSelectedData,
} from 'reduxpath/ducks/Occupation/Edit'

import {
  removeOccupation,
} from 'reduxpath/ducks/Occupation/Remove'

import Occupations from 'components/TopicsOccupation/UserSubmission'

const mapStateToProps = state => ({
  dataList: state.OccupationList.occupationUserSubmission,
  isModalUserSubmissionOpen: state.OccupationList.isModalSubmissionOpen,
  action: state.OccupationList.action,
  idDataSelected: state.OccupationList.idOccupationSelected,
  selectedData: state.OccupationEdit.selectedData,
  user: state.Auth.me.user,
  filterNameUserSubmission: state.OccupationList.filterNameUserSubmission,
  dataUserSubmissionSelected: state.OccupationList.occupationUserSubmissionSelected,
  isModalMergeOpen: state.OccupationList.isModalMergeOpen,
  inputMergeName: state.OccupationList.inputMergeName,
  typeMerge: state.OccupationList.typeMerge,
  dataSelection: state.OccupationList.occupationSelection,
  existingDataSelected: state.OccupationList.existingOccupationSelected,
  isDialogAlertOpen: state.OccupationList.isDialogAlertOpen,
  dialogAlertMessage: state.OccupationList.dialogAlertMessage,
  userSubmissionFilter: state.OccupationList.userSubmissionFilter,
  dataTypeActive: state.OccupationList.dataTypeActive,
  dataLiveSelected: state.OccupationList.occupationLiveDataSelected,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(filterName, userSubmissionFilter) {
    return (key) => {
      const limit = 10
      const qs = {
        limit,
        skip: key.selected * limit,
      }
      if (userSubmissionFilter.sort) {
        qs.sort = `${userSubmissionFilter.active} ${userSubmissionFilter.sort}`
      }
      if (filterName) {
        qs.where = {
          name: {
            like: `%${filterName}%`,
          },
        }
      }
      dispatch(getOccupationsUserSubmission(qs))
    }
  },

  addToPlatform(occupation) {
    return () => {
      dispatch(updateOccupation({
        id: occupation.id,
        name: occupation.name,
        status: 2,
      }, occupation.id, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }
        dispatch(getOccupations(qs))
        dispatch(getOccupationsUserSubmission(qs))
        dispatch(setModalOccupationUserSubmission(false))
        dispatch(setSelectedData({
          id: '',
          name: '',
        }))
      }))
    }
  },

  openModal(data, idOccupation = '', action = '') {
    return () => {
      dispatch(setAction(action))
      dispatch(setIdOccupationSelected(idOccupation))
      dispatch(setModalOccupationUserSubmission(data))
    }
  },

  openModalForAddToPlatform(data, occupation, action = '') {
    return () => {
      dispatch(setAction(action))
      dispatch(setSelectedData(occupation))
      dispatch(setModalOccupationUserSubmission(data))
    }
  },

  setOpenModalMerge(data, action = '') {
    return () => {
      dispatch(setAction(action))
      dispatch(setModalOccupationUserSubmission(data))
    }
  },

  deleteData(id) {
    return () => {
      dispatch(removeOccupation(id, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }

        dispatch(setModalOccupationUserSubmission(false))
        dispatch(getOccupationsUserSubmission(qs))
        dispatch(setIdOccupationSelected(''))
      }))
    }
  },

  onSearchFilter(userSubmissionFilter) {
    return (e) => {
      const limit = 10
      const qs = {
        limit,
        skip: 0,
        where: {
          name: {
            like: `%${e.target.value}%`,
          },
        },
      }
      if (userSubmissionFilter.sort) {
        qs.sort = `${userSubmissionFilter.active} ${userSubmissionFilter.sort}`
      }
      dispatch(setFilterNameUserSubmission(e.target.value))
      dispatch(getOccupationsUserSubmission(qs))
    }
  },

  onClickCheckBox(currentData) {
    return selectedData => (e) => {
      const currentSelectedData = [...currentData]
      if (e.target.checked) {
        currentSelectedData.push(selectedData)
      } else {
        const dataIndex = currentSelectedData.findIndex(data => data.id === selectedData.id)
        currentSelectedData.splice(dataIndex, 1)
      }
      dispatch(setOccupationsUserSubmissionSelected(currentSelectedData))
    }
  },

  removeSelectedData(currentData, liveCurrentData, dataTypeActive) {
    return dataIndex => () => {
      const currentSelectedData = dataTypeActive === 'liveData' ? [...liveCurrentData] : [...currentData]
      currentSelectedData.splice(dataIndex, 1)
      if (dataTypeActive === 'liveData') {
        dispatch(setOccupationLiveDataSelected(currentSelectedData))
      } else {
        dispatch(setOccupationsUserSubmissionSelected(currentSelectedData))
      }
    }
  },

  clearSelection() {
    dispatch(setOccupationsUserSubmissionSelected([]))
  },

  setIsModalMergeOpen(data) {
    return () => {
      dispatch(setDataTypeActive('userSubmission'))
      dispatch(setInputMergeName(''))
      dispatch(setIsModalMergeOpen(data))
    }
  },

  setInputMergeName(e) {
    dispatch(setInputMergeName(e.target.value))
  },

  mergeData(currentSelectedData, mergeOccupationData, typeMerge, existingDataSelected) {
    return () => {
      const dataWillBeMerge = []
      currentSelectedData.forEach((selectedData) => {
        dataWillBeMerge.push(selectedData.id)
      })
      const type = typeMerge === 'newData' ? 'newOccupation' : 'existingOccupation'
      const data = {
        occupations: dataWillBeMerge,
        [type]: mergeOccupationData,
      }

      dispatch(mergeOccupations(data, (res, err) => {
        if (err) {
          dispatch(setModalOccupationUserSubmission(false))
          dispatch(setDialogAlertMessage(`Occupation "${typeMerge === 'newData' ? mergeOccupationData : existingDataSelected}" failed created`))
          dispatch(setIsDialogAlertOpen(true))
        }

        const qs = {
          limit: 10,
          skip: 0,
        }
        dispatch(setOccupationsUserSubmissionSelected([]))
        dispatch(getOccupationsUserSubmission(qs))
        dispatch(setIsModalMergeOpen(false))
        dispatch(setModalOccupationUserSubmission(false))
        dispatch(setInputMergeName(''))
        dispatch(setIsDialogAlertOpen(true))
        dispatch(setDialogAlertMessage(`Occupation "${typeMerge === 'newData' ? mergeOccupationData : existingDataSelected}" successfully merged`))
      }))
    }
  },

  setTypeMerge(e) {
    dispatch(setTypeMerge(e.target.value))
    dispatch(setExistingOccupationSelected(''))
    dispatch(setInputMergeName(''))
  },

  setExistingDataSelected(e) {
    dispatch(setExistingOccupationSelected(e.target.options[e.target.selectedIndex].text))
    dispatch(setInputMergeName(e.target.value))
  },

  searchDataToMerge(e) {
    const limit = 10
    const qs = {
      limit,
      skip: 0,
      where: {
        name: {
          like: `%${e.target.value}%`,
        },
      },
    }
    dispatch(setExistingOccupationSelected(e.target.value))
    dispatch(getOccupationSelection(qs))
  },

  setIsDialogAlertOpen(data) {
    return () => {
      dispatch(setIsDialogAlertOpen(data))
    }
  },

  sortUserSubmissionData(filterName) {
    return data => () => {
      const qs = {
        skip: 0,
        where: {
          name: {
            like: `%${filterName}%`,
          },
        },
        sort: `${data.active} ${data.sort}`,
      }
      dispatch(getOccupationsUserSubmission(qs))
      dispatch(setFilterSortUserSubmission(data))
    }
  },

  mergeDataLive(currentSelectedData, mergeOccupationData, typeMerge, existingDataSelected) {
    return () => {
      const dataWillBeMerge = []
      currentSelectedData.forEach((selectedData) => {
        dataWillBeMerge.push(selectedData.id)
      })
      const type = typeMerge === 'newData' ? 'newOccupationLive' : 'existingOccupation'
      const data = {
        occupations: dataWillBeMerge,
        [type]: mergeOccupationData,
      }

      dispatch(mergeOccupations(data, (res, err) => {
        if (err) {
          dispatch(setModalOccupationUserSubmission(false))
          dispatch(setDialogAlertMessage(`Topic "${typeMerge === 'newData' ? mergeOccupationData : existingDataSelected}" failed created`))
          dispatch(setIsDialogAlertOpen(true))
        }

        const qs = {
          limit: 10,
          skip: 0,
        }
        dispatch(setOccupationLiveDataSelected([]))
        dispatch(getOccupations(qs))
        dispatch(setIsModalMergeOpen(false))
        dispatch(setModalOccupationUserSubmission(false))
        dispatch(setInputMergeName(''))
        dispatch(setIsDialogAlertOpen(true))
        dispatch(setDialogAlertMessage(`Topic "${typeMerge === 'newData' ? mergeOccupationData : existingDataSelected}" successfully merged`))
      }))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  deleteData: dispatchProps.deleteData(stateProps.idDataSelected),
  addToPlatform: dispatchProps.addToPlatform(stateProps.selectedData),
  handlePageChange: dispatchProps.handlePageChange(
    stateProps.filterNameUserSubmission,
    stateProps.userSubmissionFilter,
  ),
  onClickCheckBox: dispatchProps.onClickCheckBox(stateProps.dataUserSubmissionSelected),
  removeSelectedData: dispatchProps.removeSelectedData(
    stateProps.dataUserSubmissionSelected,
    stateProps.dataLiveSelected,
    stateProps.dataTypeActive,
  ),
  mergeData: dispatchProps.mergeData(
    stateProps.dataUserSubmissionSelected,
    stateProps.inputMergeName,
    stateProps.typeMerge,
    stateProps.existingDataSelected,
  ),
  sortUserSubmissionData: dispatchProps.sortUserSubmissionData(stateProps.filterNameUserSubmission),
  onSearchFilter: dispatchProps.onSearchFilter(stateProps.userSubmissionFilter),
  mergeDataLive: dispatchProps.mergeDataLive(
    stateProps.dataLiveSelected,
    stateProps.inputMergeName,
    stateProps.typeMerge,
    stateProps.existingDataSelected,
  ),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Occupations)
